
import decode from 'jwt-decode';
import appConstant from '../../constants/app';
import * as utils from './/utils'

export const setLocalStorage = (key, obj) => {
  if (appConstant.TOKEN === key) {
    setSessionStorage(key, obj)
  }
  else if (appConstant.COMPANY === key) {
    setSessionStorage(key, obj)
  }
  else {
    localStorage.setItem(key, JSON.stringify(obj));
  }

};


export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const getLocalStorage = (key) => {
  if (appConstant.TOKEN === key) {
    return getCurrentToken(key)
  }
  else if (appConstant.COMPANY === key) {
    return getCurrentCompany(key)
  }
  else {
    var value = localStorage.getItem(key);
    // console.log(value, 'valuevalue');
    if (value === null) {
      return null;
    }
    return value ? JSON.parse(value) : null
  }
};


export const setSessionStorage = (key, obj) => {
  sessionStorage.setItem(key, JSON.stringify(obj));
};

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

export const getSessionStorage = (key) => {
  var value = sessionStorage.getItem(key);
  // console.log(value, 'valuevalue');
  if (value === null) {
    return null;
  }
  return value ? JSON.parse(value) : null
};


export function getTokenExpirationDate() {
  const decoded = getLocalStorage(appConstant.TOKEN)
  if (decoded && decoded.finalResult) {
    const date = decoded.finalResult[appConstant.expire]
    if (!date) {
      return null
    }
    var dateUtc = new Date(date).getTime();
    var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(dateUtc);

    return new Date(date);
  }
  else {
    return null;
  }
}

export const isTokenExpired = () => {
  const d = getTokenExpirationDate()
  if (!d) {
    return true
  }
  return !(d.valueOf() > new Date().valueOf())
}

export const isNeedToRefreshToken = () => {
  var d = getTokenExpirationDate();

  if (!d) {
    return false;
  }

  var ticks = d.valueOf() - new Date().valueOf();
  var mm = Math.round((ticks / (60 * 1000)) % 60);

  return (mm <= process.env.REACT_APP_REFRESH_TOKEN_THRESHOLD);
};

export function getProfileToken(token) {
  if (token) {
    const decoded = decode(token)
    return decoded;
  }
}

export const checkTokenIsValidStorage = () => {
  var token = getLocalStorage('token')

  if (token === null) {
    return false;
  }
  return isTokenExpired(token)
};

export const clearClientDetail = () => {
  document.title = "The Debtonator"
  removeSessionStorage(appConstant.clientId);
  removeSessionStorage(appConstant.clientDetail);
  removeSessionStorage(appConstant.permissionDetail);
  removeSessionStorage(appConstant.isPayment);
}


export const clearUserCache = () => {
  removeSessionStorage(appConstant.TOKEN);
  removeLocalStorage(appConstant.TOKENS);
  removeLocalStorage(appConstant.PROFILE);
  removeLocalStorage(appConstant.COMPANIES);
  removeSessionStorage(appConstant.COMPANY);
  removeSessionStorage(appConstant.CompanyCode);
}

export const clearRestCache = () => {
  removeSessionStorage(appConstant.displayFields);
  removeSessionStorage(appConstant.filterFields);
  removeSessionStorage(appConstant.operators);
  removeSessionStorage(appConstant.clientFilters);
  removeSessionStorage(appConstant.salesRep);
  removeSessionStorage(appConstant.negotiators);
  removeSessionStorage(appConstant.loanStatus);
  removeSessionStorage(appConstant.affiliates);
  removeSessionStorage(appConstant.clientCareTemplates);
  removeSessionStorage(appConstant.debtType);
  removeSessionStorage(appConstant.attorneys);
  removeSessionStorage(appConstant.renewalfrequency);
  removeSessionStorage(appConstant.notestemplates);
  removeSessionStorage(appConstant.includeAffilaite);
  removeSessionStorage(appConstant.companyTags);  
  removeLocalStorage(appConstant.leadsearch);
  removeLocalStorage(appConstant.clientSearch);
  removeSessionStorage(appConstant.incomeType);
  removeSessionStorage(appConstant.expenseType);
  removeSessionStorage(appConstant.communicationPreferences);
  removeSessionStorage(appConstant.paymentStatus);
  removeSessionStorage(appConstant.senderPhones);
  removeSessionStorage(appConstant.answerTypes);
  removeSessionStorage(appConstant.teams);
  removeSessionStorage(appConstant.typeAnswers); 
  removeSessionStorage(appConstant.hardShipTypes); 
  removeSessionStorage(appConstant.ticketUsers);
  removeSessionStorage(appConstant.ticketTeams); 
}

export const clearMainLevelCache = () => {
  removeSessionStorage(appConstant.languages);
  removeSessionStorage(appConstant.titles);
  removeSessionStorage(appConstant.genders);
  removeSessionStorage(appConstant.states);
  removeSessionStorage(appConstant.lendertiers);
  removeSessionStorage(appConstant.purchasersStatus);
}


export const clearAllCache = () => {
  clearClientDetail();
  clearUserCache();
  clearRestCache();
  clearMainLevelCache();
}

export const getLocalStorageInternal = (key) => {
  var value = localStorage.getItem(key);
  // console.log(value, 'valuevalue');
  if (value === null) {
    return null;
  }
  return value ? JSON.parse(value) : null

};



export const getCurrentToken = () => {
  const tokens = getLocalStorageInternal(appConstant.TOKENS);

  if (tokens && tokens.length > 0) {
    const companyCode = getSessionStorage(appConstant.CompanyCode); 
    if (utils.isNullOrWhiteSpace(companyCode)) {
      return tokens[0];
    } else {

      const result = tokens.filter(w => w.code === companyCode);
      if (result && result.length > 0) {
        return result[0]
      } 
      else {
        return tokens[0];
      }
    }
  }

  return null;
}

export const getCurrentCompany = () => {
  const companies = getLocalStorageInternal(appConstant.COMPANIES);
  if (companies && companies.length > 0) {
    const companyCode = getSessionStorage(appConstant.CompanyCode); 
    if (utils.isNullOrWhiteSpace(companyCode)) {
       return companies[0];
    } else {
      const result = companies.filter(w => w.code === companyCode);
      if (result && result.length > 0) {
        return result[0]
      }  
      else {
        return companies[0];
      }
    }
  }

  return null;
}

export function getTokenIssuedDate() {
  const decoded = getLocalStorage(appConstant.TOKEN)
  if (decoded && decoded.finalResult) {
   const date = decoded.finalResult[appConstant.issued]
    if (!date) {
      return null
    }
    var dateUtc = new Date(date).getTime();
    var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(dateUtc);

    return new Date(date);
  }
  else {
    return null;
  }
}

export const refreshTokenWithInterval = () => {  

  if (!isTokenExpired()) {
    let d = getTokenExpirationDate();
    let issueDate = getTokenIssuedDate();
    if (!d || !issueDate) {
      return false;
    }

    let ticks = d.valueOf() - new Date().valueOf();
    let mm = Math.round((ticks / (60 * 1000)) % 60);

    let ticksIssue =   new Date().valueOf() - issueDate.valueOf();
    let mmIssue = Math.round((ticksIssue / (60 * 1000)) % 60);

    let interval = process.env.REACT_APP_POLLING_REFRESH_TOKEN_MINUTES;
    
    return (mmIssue >= interval && mm <= interval);
  }

  return false

}